import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNiche = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4 14C4 18.5455 7.5 22 12 22C16.5 22 20 18.5455 20 14C20 5.81818 12 2 12 2C12 6 13 12 10 12C8 12 7.5 10 7.5 6.5C7.5 6.5 4 9.45455 4 14Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgNiche;
